/**
 * Contact page map
 */

export default {

	/** @type {Element} container element */
	el: null,

	/** @type {Map} google map instance */
	map: null,

	/** @type {Marker} google map marker instance */
	marker: null,

	/** @type {Object} marker coordinates */
	coords: {lat: 29.642822, lng: -95.5439707},

	/** @type {Object} map center coordinates */
	center: {lat: 29.699, lng: -95.442},

	/** @type {Number} google map zoom level */
	zoom: 11,

	/**
	 * Initialize the map
	 */
	init() {

		this.el = document.getElementById('contact-map');

		if(!this.el) return;

		this.map = new google.maps.Map(this.el, {
			zoom: this.zoom,
			center: this.center,
			disableDefaultUI: true,
		});

		this.marker = new google.maps.Marker({
			position: this.coords,
			map: this.map,
			title: 'Slow Dough Bread Co.'
		});


	}




}